(function () {
  'use strict';

  const stringsEl = document.querySelector('[id^="NavColProductCardStrings-"]');
  if (stringsEl && !window.navColProductCardStrings) {
    try {
      window.navColProductCardStrings = JSON.parse(stringsEl.textContent);
    } catch (error) {
      /* ignore */
    }
  }

  window.initCollectionProductCardImages = window.initCollectionProductCardImages || function (root) {
    const scope = root || document;
    scope.querySelectorAll('.collection-product-card__image--primary').forEach((image) => {
      if (image.classList.contains('is-loaded')) return;
      if (image.complete && image.naturalWidth > 0) {
        image.classList.add('is-loaded');
        return;
      }
      image.addEventListener('load', () => image.classList.add('is-loaded'), { once: true });
      image.addEventListener('error', () => image.classList.add('is-loaded'), { once: true });
    });
  }

  function parseMoneyToCents(value) {
    if (!value) return 0;
    const normalized = String(value).replace(/[^\d,.-]/g, '').replace(',', '.');
    const amount = parseFloat(normalized);
    return Number.isFinite(amount) ? Math.round(amount * 100) : 0;
  }

  function formatCentsToCardPrice(cents) {
    const amount = cents / 100;
    const formatted = amount.toLocaleString('de-DE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    return '€' + formatted;
  }

  function applyPromoPricing(productCard, variantData) {
    if (!productCard || !variantData || !variantData.price) return variantData;

    const promoPercent = parseInt(productCard.dataset.promoPercent || '0', 10);
    if (!promoPercent) return variantData;

    const priceCents = parseMoneyToCents(variantData.price);
    let compareCents = parseMoneyToCents(variantData.compareAtPrice);

    if (compareCents <= priceCents) {
      compareCents = priceCents;
      const discountAmount = Math.round((priceCents * promoPercent) / 100);
      return Object.assign({}, variantData, {
        price: formatCentsToCardPrice(priceCents - discountAmount),
        compareAtPrice: formatCentsToCardPrice(compareCents)
      });
    }

    return variantData;
  }

function bindCollectionProductCardInteractions(root) {
  const scope = root || document;
  window.initCollectionProductCardImages(scope);
  // Handle second option count clicks to expand remaining options
  scope.querySelectorAll('.collection-product-card__second-option-count:not([data-listener-added])').forEach(function(optionCount) {
    optionCount.setAttribute('data-listener-added', 'true');
    
    function expandSecondOptions() {
      const optionContainer = optionCount.closest('.collection-product-card__second-option');
      const hiddenOptions = optionContainer.querySelectorAll('.collection-product-card__second-option-value--hidden');
      
      // Add expanded class to show hidden options and hide count
      optionContainer.classList.add('expanded');
      
      // Add event listeners to newly visible options
      hiddenOptions.forEach(function(option) {
        if (!option.hasAttribute('data-listener-added')) {
          option.setAttribute('data-listener-added', 'true');
          option.addEventListener('click', handleSecondOptionClick);
        }
      });
    }
    
    optionCount.addEventListener('click', expandSecondOptions);
    optionCount.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        expandSecondOptions();
      }
    });
  });

  // Handle color count clicks to expand remaining swatches
  scope.querySelectorAll('.collection-product-card__color-count:not([data-listener-added])').forEach(function(colorCount) {
    colorCount.setAttribute('data-listener-added', 'true');
    
    function expandColors() {
      const colorsContainer = colorCount.closest('.collection-product-card__colors');
      const hiddenSwatches = colorsContainer.querySelectorAll('.collection-product-card__color-swatch--hidden');
      
      // Add expanded class to show hidden swatches and hide count
      colorsContainer.classList.add('expanded');
      
      // Add event listeners to newly visible swatches
      hiddenSwatches.forEach(function(swatch) {
        if (!swatch.hasAttribute('data-listener-added')) {
    swatch.setAttribute('data-listener-added', 'true');
          swatch.addEventListener('click', handleSwatchClick);
        }
      });
    }
    
    colorCount.addEventListener('click', expandColors);
    colorCount.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
        expandColors();
      }
    });
  });

  // Function to find variant based on selected options
  function findVariantBySelectedOptions(productCard, productId) {
    // Get product handle
    const colorsContainer = productCard.querySelector('.collection-product-card__colors');
    const secondOptionContainer = productCard.querySelector('.collection-product-card__second-option');
    const productHandle = colorsContainer ? colorsContainer.dataset.productHandle : 
                         (secondOptionContainer ? secondOptionContainer.dataset.productHandle : null);
    
    // Get selected color
    const selectedColorSwatch = productCard.querySelector('.collection-product-card__color-swatch.active');
    const selectedColor = selectedColorSwatch ? selectedColorSwatch.dataset.color : null;
    
    // Get selected second option
    const selectedSecondOption = productCard.querySelector('.collection-product-card__second-option-value.active');
    const selectedSecondValue = selectedSecondOption ? selectedSecondOption.dataset.optionValue : null;
    
    // If we have both options selected, we need to find the variant that matches BOTH
    if (selectedColor && selectedSecondValue && productHandle) {
      // Fetch product data to find the exact variant match
      return fetchProductVariants(productHandle, selectedColor, selectedSecondValue, selectedColorSwatch.dataset.variantImage);
    } else if (selectedColor) {
      // Only color selected
      return Promise.resolve({
        variantId: selectedColorSwatch.dataset.variantId,
        available: selectedColorSwatch.dataset.variantAvailable === 'true',
        image: selectedColorSwatch.dataset.variantImage,
        price: selectedColorSwatch.dataset.variantPrice,
        compareAtPrice: selectedColorSwatch.dataset.variantComparePrice || null
      });
    } else if (selectedSecondValue) {
      // Only second option selected
      return Promise.resolve({
        variantId: selectedSecondOption.dataset.variantId,
        available: selectedSecondOption.dataset.variantAvailable === 'true',
        image: null,
        price: selectedSecondOption.dataset.variantPrice,
        compareAtPrice: selectedSecondOption.dataset.variantComparePrice || null
      });
    }
    
    return Promise.resolve(null);
  }

  // Function to fetch product variants and find exact match
  function fetchProductVariants(productHandle, selectedColor, selectedSecondValue, fallbackColorImage) {
    return fetch(`/products/${productHandle}.js`)
      .then(response => response.json())
      .then(product => {
        
        // Find the variant that matches both selected options
        const matchingVariant = product.variants.find(variant => {
          const hasColor = variant.options.includes(selectedColor);
          const hasSecondOption = variant.options.includes(selectedSecondValue);
          return hasColor && hasSecondOption;
        });
        
        if (matchingVariant) {
          
          // Get the variant's featured image or fallback to product images
          let variantImage = fallbackColorImage; // Default fallback
          
          if (matchingVariant.featured_image && matchingVariant.featured_image.src) {
            // Use the variant's specific image
            variantImage = matchingVariant.featured_image.src;
          } else if (matchingVariant.featured_image) {
            // Handle different image object structures
            variantImage = matchingVariant.featured_image;
        } else {
            // Look for images in the product that might match this variant
            const variantImageObj = product.images.find(img => 
              img.variant_ids && img.variant_ids.includes(matchingVariant.id)
            );
            if (variantImageObj) {
              variantImage = variantImageObj.src;
            }
          }
          
          // Format prices using Shopify's money format
          const formatPrice = (price) => {
            // Convert cents to currency value
            const amount = price / 100;
            
            // Format with comma decimal separator and currency symbol before amount
            const formatted = amount.toLocaleString('de-DE', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            });
            return '€' + formatted;
          };
          
          return {
            variantId: matchingVariant.id,
            available: matchingVariant.available,
            image: variantImage,
            price: formatPrice(matchingVariant.price),
            compareAtPrice: matchingVariant.compare_at_price ? formatPrice(matchingVariant.compare_at_price) : null
          };
      } else {
          // Fallback to color-only variant
          const colorVariant = product.variants.find(variant => 
            variant.options.includes(selectedColor)
          );
          
          if (colorVariant) {
            let colorVariantImage = fallbackColorImage;
            
            // Try to get the color variant's specific image
            if (colorVariant.featured_image && colorVariant.featured_image.src) {
              colorVariantImage = colorVariant.featured_image.src;
            } else if (colorVariant.featured_image) {
              colorVariantImage = colorVariant.featured_image;
            } else {
              const colorImageObj = product.images.find(img => 
                img.variant_ids && img.variant_ids.includes(colorVariant.id)
              );
              if (colorImageObj) {
                colorVariantImage = colorImageObj.src;
              }
            }
            
            // Format prices using Shopify's money format
            const formatPrice = (price) => {
              // Convert cents to currency value
              const amount = price / 100;
              
              // Format with comma decimal separator and currency symbol before amount
              const formatted = amount.toLocaleString('de-DE', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              });
              return '€' + formatted;
            };
            
            return {
              variantId: colorVariant.id,
              available: colorVariant.available,
              image: colorVariantImage,
              price: formatPrice(colorVariant.price),
              compareAtPrice: colorVariant.compare_at_price ? formatPrice(colorVariant.compare_at_price) : null
            };
          }
          
          return {
            variantId: null,
            available: false,
            image: fallbackColorImage
          };
        }
      })
      .catch(error => {
        console.error('Error fetching product variants:', error);
        // Fallback to color swatch data
        return {
          variantId: null,
          available: false,
          image: fallbackColorImage
        };
      });
  }

  // Function to update variant and UI
  function updateVariantAndUI(productCard, productId, variantData, colorName = null) {
    if (!variantData) return;

    variantData = applyPromoPricing(productCard, variantData);
    
    // Update product image - now considers both color and secondary option
    updateProductImage(productCard, variantData, colorName);
    
    // Update product price
    updateProductPrice(productCard, variantData);
    
    // Update product badges (sale/sold out)
    updateProductBadges(productCard, variantData);
      
      // Update hidden variant ID input
      const variantInput = productCard.querySelector('.product-variant-id[data-product-id="' + productId + '"]');
    if (variantInput && variantData.variantId) {
      variantInput.value = variantData.variantId;
      variantInput.disabled = !variantData.available;
      }
      
      // Update add to cart button
      const addButton = productCard.querySelector('.collection-product-card__add-button');
      if (addButton) {
        const buttonText = addButton.querySelector('span');
        if (buttonText) {
        if (variantData.available) {
            buttonText.textContent = (window.navColProductCardStrings && window.navColProductCardStrings.addToCart) || 'Add to cart';
            addButton.disabled = false;
          } else {
            buttonText.textContent = (window.navColProductCardStrings && window.navColProductCardStrings.soldOut) || 'Sold out';
            addButton.disabled = true;
          }
        }
      }
  }

  // Function to update product price based on selected variant
  function updateProductPrice(productCard, variantData) {
    if (!variantData || !variantData.price) return;

    const priceContainer = productCard.querySelector('.collection-product-card__price');
    if (!priceContainer) return;

    // Update current price
    const currentPriceElement = priceContainer.querySelector('.collection-product-card__price-current');
    if (currentPriceElement && variantData.price) {
      currentPriceElement.textContent = variantData.price;
      
      // Update sale class based on compare at price
      if (variantData.compareAtPrice && parseFloat(variantData.compareAtPrice.replace(/[^0-9.-]+/g, '')) > parseFloat(variantData.price.replace(/[^0-9.-]+/g, ''))) {
        currentPriceElement.classList.add('collection-product-card__price-current--sale');
      } else {
        currentPriceElement.classList.remove('collection-product-card__price-current--sale');
      }
    }

    // Update or create compare at price
    let compareAtPriceElement = priceContainer.querySelector('.collection-product-card__price-compare');
    
    if (variantData.compareAtPrice && parseFloat(variantData.compareAtPrice.replace(/[^0-9.-]+/g, '')) > parseFloat(variantData.price.replace(/[^0-9.-]+/g, ''))) {
      // Show compare at price
      if (!compareAtPriceElement) {
        compareAtPriceElement = document.createElement('span');
        compareAtPriceElement.className = 'collection-product-card__price-compare';
        priceContainer.insertBefore(compareAtPriceElement, currentPriceElement);
      }
      compareAtPriceElement.textContent = variantData.compareAtPrice;
      compareAtPriceElement.style.display = 'inline';
    } else {
      // Hide compare at price
      if (compareAtPriceElement) {
        compareAtPriceElement.style.display = 'none';
      }
    }
  }

  // Function to update product badges based on selected variant
  function updateProductBadges(productCard, variantData) {
    if (!variantData) return;

    const badgesContainer = productCard.querySelector('.collection-product-card__badges');
    if (!badgesContainer) return;

    const soldOutBadge = badgesContainer.querySelector('.collection-product-card__badge--sold-out');
    const saleBadge = badgesContainer.querySelector('.collection-product-card__badge--sale');

    // Update sold out badge
    if (soldOutBadge) {
      soldOutBadge.style.display = !variantData.available ? 'inline-block' : 'none';
    }

    // Update sale badge - check if variant is on sale
    if (saleBadge) {
      const isOnSale = variantData.available && 
                      variantData.compareAtPrice && 
                      parseFloat(variantData.compareAtPrice.replace(/[^0-9.-]+/g, '')) > parseFloat(variantData.price.replace(/[^0-9.-]+/g, ''));
      
      saleBadge.style.display = isOnSale ? 'inline-block' : 'none';
    }
  }

  // Function to update product image based on selected variant
  function updateProductImage(productCard, variantData, colorName = null) {
    const productImage = productCard.querySelector('.collection-product-card__image');
    if (!productImage) return;

    // Get selected options for alt text
    const selectedColorSwatch = productCard.querySelector('.collection-product-card__color-swatch.active');
    const selectedSecondOption = productCard.querySelector('.collection-product-card__second-option-value.active');
    const selectedColor = selectedColorSwatch ? selectedColorSwatch.dataset.color : null;
    const selectedSecondValue = selectedSecondOption ? selectedSecondOption.dataset.optionValue : null;

    // If we have variant data with an image, use it
    if (variantData.image && variantData.image !== '') {
      
      productImage.classList.remove('is-loaded');
      productImage.src = variantData.image;
      
      // Update alt text with both options
      const productTitle = productCard.querySelector('.collection-product-card__title').textContent;
      let altText = productTitle;
      if (selectedColor) altText += ' - ' + selectedColor;
      if (selectedSecondValue) altText += ' - ' + selectedSecondValue;
      productImage.alt = altText;
      
      // Update srcset for responsive images
      productImage.srcset = variantData.image.replace('_800x800', '_165x165') + ' 165w, ' +
                            variantData.image.replace('_800x800', '_360x360') + ' 360w, ' +
                            variantData.image.replace('_800x800', '_533x533') + ' 533w, ' +
                            variantData.image.replace('_800x800', '_720x720') + ' 720w, ' +
                            variantData.image + ' 800w';
      productImage.addEventListener('load', () => productImage.classList.add('is-loaded'), { once: true });
    } else {
    }
  }

  // Handle color swatch clicks (only if not already handled)
  function handleSwatchClick(e) {
    e.preventDefault();
    
    const productId = this.closest('.collection-product-card__colors').dataset.productId;
    const colorName = this.dataset.color;
    
    // Find the product card container
    const productCard = this.closest('.collection-product-card');
    if (!productCard) return;
    
    // Update active swatch
    productCard.querySelectorAll('.collection-product-card__color-swatch').forEach(s => s.classList.remove('active'));
    this.classList.add('active');
    
    // Find the correct variant based on all selected options
    const variantPromise = findVariantBySelectedOptions(productCard, productId);
    variantPromise.then(variantData => {
      updateVariantAndUI(productCard, productId, variantData, colorName);
    });
  }

  // Handle second option clicks
  function handleSecondOptionClick(e) {
    e.preventDefault();
    
    const productId = this.closest('.collection-product-card__second-option').dataset.productId;
    const optionValue = this.dataset.optionValue;
    
    // Find the product card container
    const productCard = this.closest('.collection-product-card');
    if (!productCard) return;
    
    // Update active option
    productCard.querySelectorAll('.collection-product-card__second-option-value').forEach(o => o.classList.remove('active'));
    this.classList.add('active');
    
    // Find the correct variant based on all selected options
    const variantPromise = findVariantBySelectedOptions(productCard, productId);
    variantPromise.then(variantData => {
      updateVariantAndUI(productCard, productId, variantData);
    });
  }

  // Add event listeners to initially visible swatches
  scope.querySelectorAll('.collection-product-card__color-swatch:not([data-listener-added])').forEach(function(swatch) {
    swatch.setAttribute('data-listener-added', 'true');
    swatch.addEventListener('click', handleSwatchClick);
  });

  // Add event listeners to initially visible second options
  scope.querySelectorAll('.collection-product-card__second-option-value:not([data-listener-added])').forEach(function(option) {
    option.setAttribute('data-listener-added', 'true');
    option.addEventListener('click', handleSecondOptionClick);
  });
}

document.addEventListener('DOMContentLoaded', function () {
  bindCollectionProductCardInteractions(document);
});

window.bindCollectionProductCardInteractions = bindCollectionProductCardInteractions;
})();
